.description {
  font-size: 12px;
  color: #605e5c;
  margin-top: 30px;
  margin-bottom: 20px;
}
